import { CancelRounded, CheckCircleRounded, DeleteRounded } from "@mui/icons-material";
import {
	Box,
	Button,
	Checkbox,
	Dialog,
	DialogActions,
	DialogTitle,
	FormControl,
	FormHelperText,
	IconButton,
	LinearProgress,
	MenuItem,
	Select,
	Typography,
} from "@mui/material";
import { blue, grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { AuthState } from "context/AuthContext";
import { GlobalState } from "context/GlobalContext";
import { PimDashboardState } from "context/PimDashboardContext";
import {
	trimsTableColumns,
	trimBreakdownTableColumns,
	pimConsumpGarmentOptions,
	pimDescCatAssociationObj,
	trimsRequiredForValues,
	trimsSourcingValues,
	pimTrimBreakdownAssociationObj,
} from "../../data";
import { styleColorAssocObj } from "components/PimDashboard/data";
import { channelTypes } from "components/PimDashboard/DashboardComponents/Buying/BuyingSheet/data";
import { inputTypes } from "data/globalData";
import { useEffect, useState } from "react";

const colStyle = {
	headerAlign: "center",
	align: "center",
};
const trimsValueOptions = {
	[trimsTableColumns.category.key]: [
		{
			name: "BUTTONS",
			key: "BUTTONS",
			[pimDescCatAssociationObj]: [
				{
					[trimsTableColumns.description.key]: "GASTRA BUTTON 3340BT",
					[trimsTableColumns.consumption.key]: 1,
					[trimsTableColumns.consumption_unit.key]: "PCS",
					[trimsTableColumns.per_garment_qty.key]: 1,
					[trimsTableColumns.wastage_percent.key]: 0,
				},
			],
		},
		{
			name: "SIZE LABEL",
			key: "SIZE LABEL",
			[pimDescCatAssociationObj]: [
				{
					[trimsTableColumns.description.key]: "POE WOVEN SIZE LABEL-157",
					[trimsTableColumns.consumption.key]: 1,
					[trimsTableColumns.consumption_unit.key]: "NOS",
					[trimsTableColumns.per_garment_qty.key]: 1,
					[trimsTableColumns.wastage_percent.key]: 0,
				},
			],
		},
		{
			name: "POLYBAG",
			key: "POLYBAG",
			[pimDescCatAssociationObj]: [
				{
					[trimsTableColumns.description.key]: `"Z B" PL 150G 9WX12L" S/K`,
					[trimsTableColumns.consumption.key]: 1,
					[trimsTableColumns.consumption_unit.key]: "PCS",
					[trimsTableColumns.per_garment_qty.key]: 1,
					[trimsTableColumns.wastage_percent.key]: 0,
				},
			],
		},
	],
};

const RightWrongBox = ({ field, row }) => {
	return (
		<Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center">
			{row[field] === true ? <CheckCircleRounded color="success" /> : <CancelRounded color="error" />}
		</Box>
	);
};
export const WhiteBgBox = ({ field, row }) => {
	return (
		<Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center" sx={{ background: "white" }}>
			<span>{row[field]}</span>
		</Box>
	);
};

const TrimsTable = ({ styleTrimsArr, updatedTrimsArr, setUpdatedTrimsArr, publishDisabled, categoryMaster }) => {
	const { setTrimsCatDescObj, trimsCatDescObj, selectedStyle } = PimDashboardState();
	const { setSnackBar, setSnackBarOpen, snackBar } = GlobalState();
	const { user } = AuthState();

	const deftrimsColumns = [
		{
			...trimsTableColumns.category,
			width: 120,
			...colStyle,
			headerName: trimsTableColumns.category.name,
			field: trimsTableColumns.category.key,
			renderCell: ({ field, row }) => {
				return (
					<Box component="div" onClick={() => openConsumptionPopup(row)}>
						<span style={{ color: blue[600] }}>{row[field]}</span>
					</Box>
				);
			},
		},
		{
			...trimsTableColumns.description,
			field: trimsTableColumns.description.key,
			headerName: trimsTableColumns.description.name,
			width: 180,
			...colStyle,
		},
		{
			...trimsTableColumns.color_level,
			width: 100,
			...colStyle,
			headerName: trimsTableColumns.color_level.name,
			field: trimsTableColumns.color_level.key,
			renderCell: ({ field, row }) => {
				return <RightWrongBox field={field} row={row} />;
			},
		},
		{
			...trimsTableColumns.size_level,
			headerName: trimsTableColumns.size_level.name,
			field: trimsTableColumns.size_level.key,
			width: 100,
			...colStyle,
			renderCell: ({ field, row }) => {
				return <RightWrongBox field={field} row={row} />;
			},
		},
		{
			...trimsTableColumns.channel_level,
			headerName: trimsTableColumns.channel_level.name,
			field: trimsTableColumns.channel_level.key,
			width: 100,
			...colStyle,
			renderCell: ({ field, row }) => {
				return <RightWrongBox field={field} row={row} />;
			},
		},
		{
			...trimsTableColumns.consumption,
			field: trimsTableColumns.consumption.key,
			headerName: trimsTableColumns.consumption.name,
			width: 120,
			...colStyle,
			editable: true,
			renderCell: ({ field, row }) => {
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...trimsTableColumns.consumption_unit,
			field: trimsTableColumns.consumption_unit.key,
			headerName: trimsTableColumns.consumption_unit.name,
			width: 120,
			...colStyle,
		},
		{
			...trimsTableColumns.per_garment_qty,
			field: trimsTableColumns.per_garment_qty.key,
			headerName: trimsTableColumns.per_garment_qty.name,
			width: 120,
			editable: true,
			...colStyle,
			renderCell: ({ field, row }) => {
				return <WhiteBgBox field={field} row={row} />;
			},
		},

		{
			...trimsTableColumns.wastage_percent,
			field: trimsTableColumns.wastage_percent.key,
			headerName: trimsTableColumns.wastage_percent.name,
			width: 120,
			...colStyle,
			renderCell: ({ field, row }) => {
				return <WhiteBgBox field={field} row={row} />;
			},
			editable: true,
		},
		{
			...trimsTableColumns.req_for,
			field: trimsTableColumns.req_for.key,
			headerName: trimsTableColumns.req_for.name,
			width: 120,
			...colStyle,
			renderCell: ({ field, row }) => {
				return <WhiteBgBox field={field} row={row} />;
			},
			editable: true,
			type: "singleSelect",
			valueOptions: [inputTypes.select, ...Object.keys(trimsRequiredForValues)],
		},
		{
			...trimsTableColumns.sourcing,
			field: trimsTableColumns.sourcing.key,
			headerName: trimsTableColumns.sourcing.name,
			width: 120,
			...colStyle,
			renderCell: ({ field, row }) => {
				return <WhiteBgBox field={field} row={row} />;
			},
			editable: true,
			type: "singleSelect",
			valueOptions: [inputTypes.select, ...Object.keys(trimsSourcingValues)],
		},
		{
			...trimsTableColumns.price,
			field: trimsTableColumns.price.key,
			headerName: trimsTableColumns.price.name,
			width: 120,
			...colStyle,
		},
		{
			...trimsTableColumns.price_currency,
			field: trimsTableColumns.price_currency.key,
			headerName: trimsTableColumns.price_currency.name,
			width: 120,
			...colStyle,
		},
		{
			headerName: "Delete",
			width: 120,
			...colStyle,
			renderCell: ({ row }) => {
				return (
					<IconButton onClick={() => handleDeleteTrimsClick(row)} disabled={publishDisabled}>
						<DeleteRounded />
					</IconButton>
				);
			},
		},
	];
	const deftrimsConsumptionColumns = [
		{
			...trimBreakdownTableColumns.category,
			width: 120,
			...colStyle,
			headerName: trimBreakdownTableColumns.category.name,
			field: trimBreakdownTableColumns.category.key,
		},
		{
			...trimBreakdownTableColumns.description,
			field: trimBreakdownTableColumns.description.key,
			headerName: trimBreakdownTableColumns.description.name,
			width: 180,
			...colStyle,
		},
		{
			...trimBreakdownTableColumns.gar_color,
			width: 100,
			...colStyle,
			headerName: trimBreakdownTableColumns.gar_color.name,
			field: trimBreakdownTableColumns.gar_color.key,
		},
		{
			...trimBreakdownTableColumns.item_color,
			headerName: trimBreakdownTableColumns.item_color.name,
			field: trimBreakdownTableColumns.item_color.key,
			width: 100,
			...colStyle,
			editable: true,
			renderCell: ({ field, row }) => {
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...trimBreakdownTableColumns.gar_size,
			width: 100,
			...colStyle,
			headerName: trimBreakdownTableColumns.gar_size.name,
			field: trimBreakdownTableColumns.gar_size.key,
		},
		{
			...trimBreakdownTableColumns.item_size,
			headerName: trimBreakdownTableColumns.item_size.name,
			field: trimBreakdownTableColumns.item_size.key,
			width: 100,
			...colStyle,
			editable: true,
			renderCell: ({ field, row }) => {
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...trimBreakdownTableColumns.gar_channel,
			headerName: trimBreakdownTableColumns.gar_channel.name,
			field: trimBreakdownTableColumns.gar_channel.key,
			width: 100,
			...colStyle,
		},
		{
			...trimBreakdownTableColumns.item_channel,
			headerName: trimBreakdownTableColumns.item_channel.name,
			field: trimBreakdownTableColumns.item_channel.key,
			width: 100,
			...colStyle,
			editable: true,
			renderCell: ({ field, row }) => {
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...trimBreakdownTableColumns.consumption,
			headerName: trimBreakdownTableColumns.consumption.name,
			field: trimBreakdownTableColumns.consumption.key,
			width: 120,
			...colStyle,
			editable: true,
			renderCell: ({ field, row }) => {
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...trimBreakdownTableColumns.consumption_unit,
			field: trimBreakdownTableColumns.consumption_unit.key,
			headerName: trimBreakdownTableColumns.consumption_unit.name,
			width: 120,
			...colStyle,
		},
		{
			...trimBreakdownTableColumns.per_garment_qty,
			field: trimBreakdownTableColumns.per_garment_qty.key,
			headerName: trimBreakdownTableColumns.per_garment_qty.name,
			width: 120,
			editable: true,
			...colStyle,
			renderCell: ({ field, row }) => {
				return <WhiteBgBox field={field} row={row} />;
			},
		},

		{
			...trimBreakdownTableColumns.wastage_percent,
			field: trimBreakdownTableColumns.wastage_percent.key,
			headerName: trimBreakdownTableColumns.wastage_percent.name,
			width: 120,
			...colStyle,
			renderCell: ({ field, row }) => {
				return <WhiteBgBox field={field} row={row} />;
			},
			editable: true,
		},
		{
			...trimBreakdownTableColumns.req_for,
			field: trimBreakdownTableColumns.req_for.key,
			headerName: trimBreakdownTableColumns.req_for.name,
			width: 120,
			...colStyle,
		},
		{
			...trimBreakdownTableColumns.sourcing,
			field: trimBreakdownTableColumns.sourcing.key,
			headerName: trimBreakdownTableColumns.sourcing.name,
			width: 120,
			...colStyle,
		},
		{
			...trimBreakdownTableColumns.price,
			field: trimBreakdownTableColumns.price.key,
			headerName: trimBreakdownTableColumns.price.name,
			width: 120,
			...colStyle,
		},
		{
			...trimBreakdownTableColumns.price_currency,
			field: trimBreakdownTableColumns.price_currency.key,
			headerName: trimBreakdownTableColumns.price_currency.name,
			width: 120,
			...colStyle,
		},
	];
	const [trimsColumns, setTrimsColumns] = useState(deftrimsColumns);
	const [trimsArr, setTrimsArr] = useState(styleTrimsArr?.length ? styleTrimsArr : []);
	const [trimsConsumptionColumns, setTrimsConsumptionColumns] = useState(deftrimsConsumptionColumns);

	const defTrimGroupObj = Object.keys(trimsTableColumns).reduce((acc, row) => {
		acc[trimsTableColumns[row].key] = trimsTableColumns[row]?.defaultValue;
		return acc;
	}, {});
	const [trimToAdd, setTrimToAdd] = useState(defTrimGroupObj);
	// for select Input
	const [selectedTrimCategoryDesc, setSelectedTrimCategoryDesc] = useState();
	// const [catDescArr, setCatDescArr] = useState();
	const [consumptionPopup, setConsumptionPopup] = useState(false);
	const [selectedTrim, setSelectedTrim] = useState();
	const [descriptionLoad, setDescriptionLoad] = useState(false);

	console.log(updatedTrimsArr, "updatedTrimsArr");

	const handleConsumptionPopupClose = () => {
		setConsumptionPopup(false);
	};

	const updateTrimDetailsToConsumptionRows = (trimObj, consumptionArr) => {
		return consumptionArr?.map((row) => {
			row[trimBreakdownTableColumns.category.key] = trimObj[trimBreakdownTableColumns.category.key];
			row[trimBreakdownTableColumns.description.key] = trimObj[trimBreakdownTableColumns.description.key];
			row[trimBreakdownTableColumns.consumption.key] = trimObj[trimBreakdownTableColumns.consumption.key];
			row[trimBreakdownTableColumns.consumption_unit.key] = trimObj[trimBreakdownTableColumns.consumption_unit.key];
			row[trimBreakdownTableColumns.per_garment_qty.key] = trimObj[trimBreakdownTableColumns.per_garment_qty.key];
			row[trimBreakdownTableColumns.wastage_percent.key] = trimObj[trimBreakdownTableColumns.wastage_percent.key];
			row[trimBreakdownTableColumns.req_for.key] = trimObj[trimBreakdownTableColumns.req_for.key];
			row[trimBreakdownTableColumns.sourcing.key] = trimObj[trimBreakdownTableColumns.sourcing.key];
			row[trimBreakdownTableColumns.price.key] = trimObj[trimBreakdownTableColumns.price.key];
			row[trimBreakdownTableColumns.price_currency.key] = trimObj[trimBreakdownTableColumns.price_currency.key];

			return row;
		});
	};

	const handleAddTrimGroup = () => {
		let obj = trimToAdd;
		if (
			!obj ||
			obj[trimsTableColumns.category.key] === inputTypes.select ||
			obj[trimsTableColumns.description.key] === inputTypes.select
		) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Select Details `,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			return;
		}
		console.log(selectedStyle, "dsbfvkwejmFGVsdjfhweiykasdhn");
		const colorARR =
			selectedStyle && obj[trimsTableColumns.color_level.key] === true
				? selectedStyle[styleColorAssocObj]
				: [{ ["color"]: "ALL" }];
		const channelArr =
			obj[trimsTableColumns.channel_level.key] === true
				? Object.keys(channelTypes)?.map((row) => {
						return { channel: row };
					})
				: [{ channel: "ALL" }];

		let consumpTableArr = [];
		const defconsumpTableRow = {
			...Object.keys(trimBreakdownTableColumns).reduce((acc, row) => {
				acc[row] = trimBreakdownTableColumns[row]?.defaultValue;
				return acc;
			}, {}),
			...updateTrimDetailsToConsumptionRows(obj, [{}])[0],
		};
		let no = new Date().valueOf();
		colorARR?.forEach((color) => {
			channelArr?.forEach((channel) => {
				consumpTableArr.push({
					id: ++no,
					is_new: true,
					...defconsumpTableRow,
					[trimBreakdownTableColumns.gar_color.key]: color["color"],
					[trimBreakdownTableColumns.item_color.key]: color["color"],
					[trimBreakdownTableColumns.gar_channel.key]: channel.channel,
					[trimBreakdownTableColumns.item_channel.key]: channel.channel,
					[trimBreakdownTableColumns.gar_size.key]:
						obj[trimsTableColumns.size_level.key] === true
							? pimConsumpGarmentOptions.PENDING.key
							: pimConsumpGarmentOptions.ALL.key,
					[trimBreakdownTableColumns.item_size.key]:
						obj[trimsTableColumns.size_level.key] === true
							? pimConsumpGarmentOptions.PENDING.key
							: pimConsumpGarmentOptions.ALL.key,
				});
			});
		});
		let objToAdd = {
			...trimToAdd,
			is_new: true,
			id: new Date().valueOf(),
			[pimTrimBreakdownAssociationObj]: consumpTableArr,
		};
		if (trimsArr?.length >= 0) {
			setTrimsArr([...trimsArr, objToAdd]);
		} else setTrimsArr([objToAdd]);
		setUpdatedTrimsArr([...updatedTrimsArr, objToAdd]);
		setTrimToAdd(defTrimGroupObj);
	};

	const handleCatgorySelectChange = async (e) => {
		let arr = [];
		setDescriptionLoad(true);
		if (trimsCatDescObj && trimsCatDescObj[e.target.value]) {
			arr = trimsCatDescObj[e.target.value];
			setDescriptionLoad(false);
		} else {
			const res = await axios.get(`/api/master/get_commodity_cat_desc_master?category=${e.target.value}`);
			setTrimsCatDescObj({ ...trimsCatDescObj, [e.target.value]: res.data });
			arr = res.data;
			setDescriptionLoad(false);
		}

		setSelectedTrimCategoryDesc(arr);

		setTrimToAdd({
			...trimToAdd,
			[trimsTableColumns.category.key]: e.target.value,
			[trimsTableColumns.description.key]: inputTypes.select,
		});
	};
	function openConsumptionPopup(selectedTrim) {
		setConsumptionPopup(true);
		setSelectedTrim(selectedTrim);
	}
	const handleTrimTableRowUpdate = (updated, old) => {
		let updatedObj = {
			...updated,
			[pimTrimBreakdownAssociationObj]: updateTrimDetailsToConsumptionRows(updated, updated[pimTrimBreakdownAssociationObj]),
		};
		setTrimsArr(
			trimsArr?.map((row) => {
				if (row?.id === updated?.id) return updatedObj;
				else return row;
			}),
		);
		setUpdatedTrimsArr(
			updatedTrimsArr?.map((row) => {
				if (row?.id === updated?.id) return updatedObj;
				else return row;
			}),
		);
		return updatedObj;
	};
	const handleConsumptionTableRowUpdate = (updated, old) => {
		let updatedObj = {
			...selectedTrim,
			[pimTrimBreakdownAssociationObj]: selectedTrim[pimTrimBreakdownAssociationObj]?.map((row) => {
				if (row?.id === updated?.id) return { ...updated, updated_by: user?.email };
				else return row;
			}),
		};
		setTrimsArr(
			trimsArr?.map((row) => {
				if (row?.id === updatedObj?.id) return updatedObj;
				else return row;
			}),
		);
		setUpdatedTrimsArr([...updatedTrimsArr?.filter((row) => row.id !== updatedObj?.id), updatedObj]);
		return updated;
	};
	const handleDeleteTrimsClick = async (row) => {
		try {
			if (!row.is_new) {
				await axios.delete(`/api/fabric_trims/delete_trims/${row.id}`).then((res) => {
					setSnackBarOpen(true);
					setSnackBar({
						...snackBar,
						message: `Fabric Deleted `,
						severity: "success",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
				});
			} else {
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: `Fabric Deleted `,
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
			}
			setTrimsArr(trimsArr.filter((fab) => fab?.id !== row.id));
			setUpdatedTrimsArr(updatedTrimsArr?.filter((fab) => fab?.id !== row.id));
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Error Occured `,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		}
	};
	return (
		<Box pt={2}>
			<Box display="flex" alignItems="center" flexWrap="wrap">
				<Typography pb={0} variant="h6" width="100%">
					Accessories
				</Typography>
				{/* <Divider orientation="horizontal" variant="fullWidth" /> */}
				<Box display="flex" justifyContent="space-between" alignItems="center">
					<Box
						sx={{
							alignSelf: "flex-start",
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
							columnGap: 1,
							p: 1,
							// background: grey[200],
							borderRadius: 1,
						}}>
						<FormControl>
							<Select
								sx={{ width: 170 }}
								size="small"
								fullWidth
								variant="outlined"
								MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}
								value={
									trimToAdd && trimToAdd[trimsTableColumns.category.key]
										? trimToAdd[trimsTableColumns.category.key]
										: inputTypes.SELECT.key
								}
								onChange={(e) => handleCatgorySelectChange(e)}>
								<MenuItem value={inputTypes.SELECT.key}>
									<span style={{ color: grey[400] }}>Select Category</span>
								</MenuItem>
								{categoryMaster?.map((row) => {
									let cat = row[trimsTableColumns?.category.key] ? row[trimsTableColumns?.category.key] : "";

									return (
										<MenuItem key={cat} value={cat}>
											{cat}
										</MenuItem>
									);
								})}
							</Select>
							<FormHelperText>
								<LinearProgress sx={{ display: descriptionLoad ? "block" : "none" }} />
							</FormHelperText>
						</FormControl>

						<Select
							sx={{ width: 170 }}
							size="small"
							fullWidth
							variant="outlined"
							MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}
							value={
								trimToAdd && trimToAdd[trimsTableColumns.description.key]
									? trimToAdd[trimsTableColumns.description.key]
									: inputTypes.SELECT.key
							}
							onChange={(e) => {
								let selectedTrimGrpDesc = selectedTrimCategoryDesc?.filter(
									(row) => row[trimsTableColumns.description.key] === e.target.value,
								);
								if (selectedTrimGrpDesc)
									setTrimToAdd({
										...trimToAdd,
										...selectedTrimGrpDesc[0],
										[trimsTableColumns.consumption_unit.key]:
											selectedTrimGrpDesc[0][trimsTableColumns.consumption_unit.sqlCol],
										// [trimsTableColumns.consumption.key]:selectedTrimGrpDesc[0][trimsTableColumns.consumption.sqlCol]
									});
							}}>
							<MenuItem value={inputTypes.SELECT.key}>
								<span style={{ color: grey[400] }}>Select Description</span>
							</MenuItem>
							{selectedTrimCategoryDesc?.map((row) => {
								return (
									<MenuItem
										key={row[trimsTableColumns.description.key]}
										value={row[trimsTableColumns.description.key]}>
										{row[trimsTableColumns.description.key]}
									</MenuItem>
								);
							})}
						</Select>
						<Box display="flex" alignItems="center">
							<Checkbox
								checked={trimToAdd && trimToAdd[trimsTableColumns.color_level.key] === true ? true : false}
								onChange={(e) =>
									setTrimToAdd({
										...trimToAdd,
										[trimsTableColumns.color_level.key]: e.target.checked ? true : false,
									})
								}
								inputProps={{ "aria-label": "controlled" }}
							/>
							<Typography variant="subtitle1">{trimsTableColumns.color_level.name}</Typography>
						</Box>
						<Box display="flex" alignItems="center">
							<Checkbox
								checked={trimToAdd && trimToAdd[trimsTableColumns.size_level.key] === true ? true : false}
								onChange={(e) =>
									setTrimToAdd({
										...trimToAdd,
										[trimsTableColumns.size_level.key]: e.target.checked ? true : false,
									})
								}
								inputProps={{ "aria-label": "controlled" }}
							/>
							<Typography variant="subtitle1">{trimsTableColumns.size_level.name}</Typography>
						</Box>
						<Box display="flex" alignItems="center">
							<Checkbox
								checked={trimToAdd && trimToAdd[trimsTableColumns.channel_level.key] === true ? true : false}
								onChange={(e) =>
									setTrimToAdd({
										...trimToAdd,
										[trimsTableColumns.channel_level.key]: e.target.checked ? true : false,
									})
								}
								inputProps={{ "aria-label": "controlled" }}
							/>
							<Typography variant="subtitle1">{trimsTableColumns.channel_level.name}</Typography>
						</Box>
						<Box>
							<Button size="small" variant="contained" onClick={handleAddTrimGroup}>
								Add Accessory
							</Button>
						</Box>
					</Box>
				</Box>
			</Box>
			<div width="100%">
				<DataGrid
					columns={trimsColumns}
					rows={trimsArr ? trimsArr : []}
					sx={{
						height: 220,
						background: grey[200],
						// border: "none",
						"& .MuiDataGrid-row": {
							// borderBottom: "1px solid lightgray",
							cursor: "pointer",
							// border: "none",
						},
						"& .MuiDataGrid-columnHeader": {
							cursor: "pointer",
						},
						"& .MuiDataGrid-cell": {
							padding: 0,
						},
						"& .MuiDataGrid-cell:focus-within": {
							outline: `solid`,
						},
						"& .MuiDataGrid-columnHeaders": {
							background: grey[100],
							// mb: 2,
							// border: "none",
							borderRadius: 1,
							// padding: "10px 0px",
						},
					}}
					onCellEditStop={(params, event) => {
						// if (params.reason === GridCellEditStopReasons.) {
						// 	event.defaultMuiPrevented = true;
						// }
					}}
					columnHeaderHeight={35}
					rowHeight={35}
					showCellVerticalBorder
					// onRowClick={(params, e) => {
					// 	onTrimsSelect(params.row);
					// }}
					initialState={{
						pagination: {
							paginationModel: { pageSize: 10 },
						},
					}}
					hideFooter
					disableRowSelectionOnClick
					processRowUpdate={handleTrimTableRowUpdate}
				/>
			</div>

			<Dialog onClose={handleConsumptionPopupClose} open={consumptionPopup} fullWidth maxWidth="lg">
				<DialogTitle>View Consumption</DialogTitle>

				{selectedTrim && (
					<Box spacing={2} padding={2}>
						<DataGrid
							columns={trimsConsumptionColumns}
							rows={selectedTrim[pimTrimBreakdownAssociationObj] ? selectedTrim[pimTrimBreakdownAssociationObj] : []}
							sx={{
								height: 220,
								background: grey[200],
								// border: "none",
								"& .MuiDataGrid-row": {
									// borderBottom: "1px solid lightgray",
									cursor: "pointer",
									// border: "none",
								},
								"& .MuiDataGrid-columnHeader": {
									cursor: "pointer",
								},
								"& .MuiDataGrid-columnHeader": {
									cursor: "pointer",
								},
								"& .MuiDataGrid-cell": {
									padding: 0,
								},
								"& .MuiDataGrid-columnHeaders": {
									background: grey[100],
									// mb: 2,
									// border: "none",
									borderRadius: 1,
									// padding: "10px 0px",
								},
							}}
							onCellEditStop={(params, event) => {
								// if (params.reason === GridCellEditStopReasons.) {
								// 	event.defaultMuiPrevented = true;
								// }
							}}
							columnHeaderHeight={35}
							rowHeight={40}
							showCellVerticalBorder
							initialState={{
								pagination: {
									paginationModel: { pageSize: 10 },
								},
							}}
							hideFooter
							disableRowSelectionOnClick
							processRowUpdate={handleConsumptionTableRowUpdate}
						/>
					</Box>
				)}
				<DialogActions sx={{ pr: 2, pb: 2 }}>
					<Button variant="outlined" onClick={handleConsumptionPopupClose}>
						Close
					</Button>
					{/* <Button variant="contained">Save</Button> */}
				</DialogActions>
			</Dialog>
		</Box>
	);
};

export default TrimsTable;
